export default "__VITE_ASSET__Df535P9k__"